import { render, staticRenderFns } from "./FullscreenLayout.vue?vue&type=template&id=f912df92&scoped=true&"
import script from "./FullscreenLayout.vue?vue&type=script&lang=js&"
export * from "./FullscreenLayout.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenLayout.vue?vue&type=style&index=0&id=f912df92&scoped=true&lang=css&"
import style1 from "./FullscreenLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912df92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
